import React from "react";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import TrexoChat from "./TrexoChat";
import Page from "@jumbo/shared/Page";
import { Toaster } from "react-hot-toast";
import HelpSection from "./components/help-section/HelpSection";

const TrexoChatRoute = [
    {
        path: ["/trexo-chat"],
        element: <TenantAdminRoute element={
            <>
                <Page component={TrexoChat} />
                <Toaster />
            </>
        } />
    },
    {
        path: ["/trexo-chat/help"],
        element: <TenantAdminRoute element={
            <>
                <Page component={HelpSection} />
                <Toaster />
            </>
        } />
    },
];
export default TrexoChatRoute;